import React from 'react';
import styled from 'styled-components/macro'
import { Building } from '../icons';

const Button = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #e7483d;
  border: none;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  z-index: 2;
  transition: opacity 0.15s ease;

  width: 92px;
  height: 78px;

  > svg {
    height: 28px;
  }

  span {
    font-size: 13px;
  }

  &:hover {
    opacity: 0.9;
  }
`;

const Text = styled.div`
  color: white;

  span {
    display: block;
  }
`;

export const VirtualTourCardWrap = styled.div`
  position: absolute;
  height: 220px;
  width: 100%;
`;

export const VirtualTourButton = ({ onClick, small, tiny, card }) => (
  <Button onClick={onClick} small={small} tiny={tiny} card={card}>
    <Building />
    <Text>
      <span>360°</span>
      <span>Virtual Tour</span>
    </Text>
  </Button>
);
